var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.637,
    height: 15,
    viewBox: "0 0 118.637 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16379",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    "data-name": "Path 3469",
    d: "M21.271-120.5H72.544a2,2,0,0,1,2,2v11a2,2,0,0,1-2,2H21.271a2,2,0,0,1-2-2v-11A2,2,0,0,1,21.271-120.5Z",
    transform: "translate(-19.271 120.501)",
    fill: "#1f70b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    d: "M21.271-120H72.544a1.5,1.5,0,0,1,1.5,1.5v11a1.5,1.5,0,0,1-1.5,1.5H21.271a1.5,1.5,0,0,1-1.5-1.5v-11A1.5,1.5,0,0,1,21.271-120Z",
    transform: "translate(-19.271 120.501)",
    fill: "none",
    stroke: "#1d70b8",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16380",
    transform: "translate(63.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M21.271-120.5H72.544a2,2,0,0,1,2,2v11a2,2,0,0,1-2,2H21.271a2,2,0,0,1-2-2v-11A2,2,0,0,1,21.271-120.5Z",
    transform: "translate(-19.271 120.501)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M21.271-120H72.544a1.5,1.5,0,0,1,1.5,1.5v11a1.5,1.5,0,0,1-1.5,1.5H21.271a1.5,1.5,0,0,1-1.5-1.5v-11A1.5,1.5,0,0,1,21.271-120Z",
    transform: "translate(-19.271 120.501)",
    fill: "none",
    stroke: "#1d70b8",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    id: "BTN",
    transform: "translate(19.031 10)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BTN")), /*#__PURE__*/React.createElement("text", {
    id: "BTN-2",
    "data-name": "BTN",
    transform: "translate(82.395 11)",
    fill: "#1d70b8",
    fontSize: 8,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BTN")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtons);
export default __webpack_public_path__ + "static/media/Buttons.fbba438ebede22a306aac3b98a62779e.svg";
export { ForwardRef as ReactComponent };